import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Box, Paper, Typography, Tabs, Tab } from "@mui/material";

import { Change } from "../components/reward/Change";
import { JCredit } from "../components/jCredit/JCredit";

export const Reward = () => {
  const location = useLocation();

  const [activeTab, setActiveTab] = useState<number>(
    location?.state?.activeTab || 0
  );

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          height: "100px",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 100,
        }}
      >
        <Paper elevation={0} sx={{ backgroundColor: "#fff" }}>
          <Typography
            variant="h5"
            width="100%"
            sx={{ px: "50px", pt: 2, wordBreak: "break-all" }}
          >
            交換
          </Typography>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              width: "100%",
            }}
          >
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="fullWidth"
              centered
              sx={{
                "& .MuiTab-root": {
                  textAlign: "center",
                  fontSize: "16px",
                },
              }}
            >
              <Tab label="景品" />
              <Tab label="寄付(開発中)" />
              <Tab label="Jクレジット(開発中)" />
            </Tabs>
          </Box>
        </Paper>
      </Box>
      {activeTab === 0 ? (
        <Change />
      ) : activeTab === 1 ? (
        <Donation />
      ) : (
        <JCredit />
      )}
    </>
  );
};

const Donation = () => {
  return <div>寄付</div>;
};
